import type { HTMLAttributes } from 'react';

import { cn } from '@/utils/styles';

type SkeletonLoaderProps = HTMLAttributes<HTMLDivElement>;

export const SkeletonLoader = ({ className, ...props }: SkeletonLoaderProps) => {
  return <div className={cn('h-9 w-full animate-pulse rounded-lg bg-white/15', className)} {...props} />;
};
